/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  Sorting,
  WarehouseTypeResponseCollectionResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class WarehouseTypes<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags WarehouseTypes
   * @name WarehouseTypesList
   * @request GET:/WarehouseTypes
   * @response `200` `WarehouseTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  warehouseTypesList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WarehouseTypeResponseCollectionResponse, ErrorResponse>({
      path: `/WarehouseTypes`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
